import { useNavigate } from "react-router-dom";
import Content from "../../components/content/Content";
import ContentBody from "../../components/content/ContentBody";
import ContentHead from "../../components/content/ContentHead";
import { faAdd, faClose, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Table from "../../components/table/table";
import { useEffect, useState } from "react";
import InputField from "../../components/inputField/inputField";
import TextEditor from "../../components/textEditor/textEditor";
import ToggleSwitch from "../../components/toggleSwitch";
import { addUpdateApi, getAllApi, uploadImageApi } from "../../api";
import he from "he";
import toast from "react-hot-toast";
import { isValidURL } from "../../utils/isValidUrl";

const About = () => {
  const navigate = useNavigate();
  const [hero, setHero] = useState([]);
  const [deleteFrom, setDeleteFrom] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [modal, setModal] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [fold1Title, setFold1Title] = useState("");
  const [fold1Description, setFold1Description] = useState("");
  const [fold2List, setFold2List] = useState([]);
  const [fold3List, setFold3List] = useState([]);
  const [fold3Title, setFold3Title] = useState("");
  const [fold4Title, setFold4Title] = useState("");
  const [fold4List, setFold4List] = useState([]);
  const [fold5Title, setFold5Title] = useState("");
  const [fold5List, setFold5List] = useState([]);
  const [fold6Title, setFold6Title] = useState("");
  const [fold6Description, setFold6Description] = useState("");
  const [fold6ShowBtn, setFold6ShowBtn] = useState("");
  const [fold6BtnText, setFold6BtnText] = useState("");
  const [fold6BtnUrl, setFold6BtnUrl] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [slug, setSlug] = useState("");
  const [metaImageUrl, setMetaImageUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [id, setId] = useState("");
  const [bottomSection, setBottomSection] = useState({
    left: {
      heading: "",
      buttonText: "",
      buttonUrl: "",
    },
    right: {
      heading: "",
      buttonText: "",
      buttonUrl: "",
    },
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getAllApi("about")
      .then((res) => {
        if (res.data.length !== 0) {
          const d = res.data[0];

          console.log(d);
          setId(d._id);
          setHero(
            d.heroCarousel.map((v) => ({
              ...v,
              image: { url: v.image, obj: "" },
              content: he.decode(v?.content || ""),
            }))
          );
          setFold1Title(d.fold1.title);
          setFold1Description(he.decode(d.fold1.description));
          setFold2List(
            d.fold2.map((v) => ({
              ...v,
              icon: { url: v.icon, obj: "" },
              description: he.decode(v.description),
            }))
          );
          setFold3List(d.fold3);
          setFold4List(
            d.fold4.map((v) => ({
              ...v,
              icon: { url: v.icon, obj: "" },
              description: he.decode(v.description),
            }))
          );
          setFold4Title(d?.fold4Title || "");
          setFold5Title(d?.fold5Title || "");
          setFold5List(
            d.fold5.map((v) => ({
              ...v,
              description: he.decode(v.description),
            }))
          );
          setFold6Title(d.fold6.title);
          setFold6Description(he.decode(d?.fold6?.description || ""));
          setMetaTitle(d.metaData.metaTitle);
          setMetaDescription(d.metaData.metaDescription);
          setMetaImageUrl(d.metaData.metaImageUrl);
          setCanonicalUrl(d.metaData.canonicalUrl);
          setSlug(d.metaData.slug);
          setBottomSection(
            d?.bottomSection || {
              left: { heading: "", buttonText: "", buttonUrl: "" },
              right: { heading: "", buttonText: "", buttonUrl: "" },
            }
          );
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getHeroData = async () => {
    const h_d = [];
    for (let i = 0; i < hero.length; i++) {
      if (hero[i].image?.obj) {
        const res = await uploadImageApi(hero[i].image?.obj, "technology");

        h_d.push({
          image: res.data.imageUrl,
          imageCaption: hero[i].imageCaption,
          imageAlt: hero[i].imageAlt,
          title: hero[i].title,
          content: hero[i].content,
        });
      } else {
        h_d.push({
          image: hero[i].image.url,
          imageCaption: hero[i].imageCaption,
          imageAlt: hero[i].imageAlt,
          title: hero[i].title,
          content: hero[i].content,
        });
      }
    }
    return h_d;
  };

  const getFold2Data = async () => {
    const f2_d = [];
    for (let i = 0; i < fold2List.length; i++) {
      if (fold2List[i].icon?.obj) {
        const res = await uploadImageApi(fold2List[i].icon?.obj, "technology");

        f2_d.push({
          icon: res.data.imageUrl,
          iconCaption: fold2List[i].iconCaption,
          iconAlt: fold2List[i].iconAlt,
          title: fold2List[i].title,
          description: fold2List[i].description,
        });
      } else {
        f2_d.push({
          icon: fold2List[i].icon.url,
          iconCaption: fold2List[i].iconCaption,
          iconAlt: fold2List[i].iconAlt,
          title: fold2List[i].title,
          description: fold2List[i].description,
        });
      }
    }
    return f2_d;
  };

  const getFold4Data = async () => {
    const f4_d = [];

    for (let i = 0; i < fold4List.length; i++) {
      if (fold4List[i].icon.obj) {
        const res = await uploadImageApi(fold4List[i].icon.obj, "technology");
        f4_d.push({ ...fold4List[i], icon: res.data.imageUrl });
      } else {
        f4_d.push({ ...fold4List[i], icon: fold4List[i].icon.url });
      }
    }

    return f4_d;
  };

  const validate = () => {
    const validationCheck = [
      // hero
      {
        condition: hero.length === 0,
        message: "Hero is required.",
      },
      {
        condition: hero.some((v) => !v.image.url),
        message: "Hero Image is required.",
      },
      {
        condition: hero.some((v) => !v.imageCaption),
        message: "Hero Image Caption is required.",
      },
      {
        condition: hero.some((v) => !v.imageAlt),
        message: "Hero Image Alt is required.",
      },
      {
        condition: hero.some((v) => !v.title),
        message: "Hero Title is required.",
      },
      {
        condition: hero.some((v) => !v.content),
        message: "Hero Content is required.",
      },

      // fold 1
      {
        condition: !fold1Title,
        message: "Fold 1 Title is required.",
      },
      {
        condition: !fold1Description,
        message: "Fold 1 Description is required.",
      },

      // Fold 2
      {
        condition: fold2List.length === 0,
        message: "Fold 2 is required.",
      },
      {
        condition: fold2List.some((v) => !v.icon.url),
        message: "Fold 2 Image is required.",
      },
      {
        condition: fold2List.some((v) => !v.iconCaption),
        message: "Fold 2 Image Caption is required.",
      },
      {
        condition: fold2List.some((v) => !v.iconAlt),
        message: "Fold 2 Image Alt is required.",
      },
      {
        condition: fold2List.some((v) => !v.title),
        message: "Fold 2 Title is required.",
      },
      {
        condition: fold2List.some((v) => !v.description),
        message: "Fold 2 Description is required.",
      },

      // Fold 3
      {
        condition: fold3List.length === 0,
        message: "Fold 3 is required.",
      },
      {
        condition: fold3List.some((v) => !v.number),
        message: "Fold 3 Number is required.",
      },
      {
        condition: fold3List.some((v) => !v.title),
        message: "Fold 3 Title is required.",
      },
      {
        condition: fold3List.some((v) => !v.subTitle),
        message: "Fold 3 Sub Title is required.",
      },

      // Fold 4
      {
        condition: fold4List.length === 0,
        message: "Fold 4 is required.",
      },
      {
        condition: !fold4Title,
        message: "Fold 4 Heading is required.",
      },
      {
        condition: fold4List.some((v) => !v.icon.url),
        message: "Fold 4 Image is required.",
      },
      {
        condition: fold4List.some((v) => !v.iconCaption),
        message: "Fold 4 Image Caption is required.",
      },
      {
        condition: fold4List.some((v) => !v.iconAlt),
        message: "Fold 4 Image Alt is required.",
      },
      {
        condition: fold4List.some((v) => !v.title),
        message: "Fold 4 Title is required.",
      },
      {
        condition: fold4List.some((v) => !v.description),
        message: "Fold 4 Description is required.",
      },
      {
        condition: fold4List.some((v) => !v.btnText && v.showBtn),
        message: "Fold 4 Button Text is required.",
      },
      {
        condition: fold4List.some((v) => !v.btnUrl && v.showBtn),
        message: "Fold 4 Button Url is required.",
      },
      {
        condition: fold4List.some((v) => !isValidURL(v.btnUrl) && v.showBtn),
        message: "Fold 4 Button Url is not valid.",
      },
      // Fold 5
      {
        condition: fold5List.length === 0,
        message: "Fold 5 is required.",
      },
      {
        condition: !fold5Title,
        message: "Fold 5 Heading is required.",
      },
      {
        condition: fold5List.some((v) => !v.year),
        message: "Fold 5 Year is required.",
      },
      {
        condition: fold5List.some((v) => !v.awardName),
        message: "Fold 5 Award Name is required.",
      },
      {
        condition: fold5List.some((v) => !v.description),
        message: "Fold 5 Description is required.",
      },
      // fold 6
      {
        condition: !fold6Title,
        message: "Fold 6 Title is required.",
      },
      {
        condition: !fold6Description,
        message: "Fold 6 Description is required.",
      },
      {
        condition: fold6ShowBtn && !fold6BtnText,
        message: "Fold 6 Button Text is required.",
      },
      {
        condition: fold6ShowBtn && !fold6BtnUrl,
        message: "Fold 6 Button Url is required.",
      },
      {
        condition: fold6ShowBtn && !isValidURL(fold6BtnUrl),
        message: "Fold 6 Button Url is not valid.",
      },
      {
        condition: !slug,
        message: "Slug is required.",
      },
      {
        condition: !metaTitle,
        message: "Meta Title is required.",
      },
      {
        condition: !metaImageUrl,
        message: "Meta Image Url is required.",
      },
      {
        condition: !isValidURL(metaImageUrl),
        message: "Invalid Meta Image Url.",
      },
      {
        condition: !metaDescription,
        message: "Meta Description is required.",
      },
      {
        condition: !canonicalUrl,
        message: "Canonical Url is required.",
      },
      {
        condition: !isValidURL(canonicalUrl),
        message: "Invalid canonical url.",
      },
    ];

    if (!bottomSection.left.heading) {
      toast.error("Left & Right CTA's Left Heading is required.");
      return false;
    }
    if (!bottomSection.left.buttonText) {
      toast.error("Left & Right CTA's Left Button Text is required.");
      return false;
    }
    if (!bottomSection.left.buttonUrl) {
      toast.error("Left & Right CTA's Left Button Url is required.");
      return false;
    }
    if (!isValidURL(bottomSection.left.buttonUrl)) {
      toast.error("Left & Right CTA's Left Button Url is invalid.");
      return false;
    }
    if (!bottomSection.right.heading) {
      toast.error("Left & Right CTA's Right Heading is required.");
      return false;
    }
    if (!bottomSection.right.buttonText) {
      toast.error("Left & Right CTA's Right Button Text is required.");
      return false;
    }
    if (!bottomSection.right.buttonUrl) {
      toast.error("Left & Right CTA's Right Button Url is required.");
      return false;
    }
    if (!isValidURL(bottomSection.right.buttonUrl)) {
      toast.error("Left & Right CTA's Right Button Url is invalid.");
      return false;
    }

    for (const check of validationCheck) {
      if (check.condition) {
        toast.error(check.message);
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (e) => {
    if (e.target.name === "btn2") {
      setLoading(true);
      getData();
    } else {
      if (validate()) {
        setLoading(true);
        const data = {
          heroCarousel: await getHeroData(),
          fold1: {
            title: fold1Title,
            description: fold1Description,
          },
          fold2: await getFold2Data(),
          fold3: fold3List,
          fold4Title: fold4Title,
          fold4: await getFold4Data(),
          fold5Title: fold5Title,
          fold5: fold5List,
          fold6: {
            title: fold6Title,
            description: fold6Description,
            buttonShow: fold6ShowBtn,
            buttonText: fold6BtnText,
            buttonUrl: fold6BtnUrl,
          },
          bottomSection,
          metaData: {
            slug,
            metaTitle,
            canonicalUrl,
            metaDescription,
            metaImageUrl,
          },
        };
        addUpdateApi({ data, type: "about", method: "patch", id })
          .then((res) => {
            toast.success("Updated Successfully.");
            getData();
            setIsChanged(false);
          })
          .catch((err) => {});
        console.log(data);
      }
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "rgba(0,0,0,.3)",
            zIndex: 100000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader"></span>
        </div>
      )}
      <Content>
        <ContentHead
          title="About"
          showBtn1={isChanged}
          btn1Text="Save"
          btn1type="filled"
          btn1Name="btn1"
          showBtn2={isChanged}
          btn2Text="Cancel"
          btn2type="outlined_del"
          btn2Name="btn2"
          onClickHandler={handleSubmit}
        />
        <ContentBody>
          <div className="grid">
            <div className="card grid">
              <h3>
                Hero{" "}
                <button
                  onClick={() => {
                    let temp = [...hero];
                    temp.push({
                      image: { url: "", obj: "" },
                      imageCaption: "",
                      imageAlt: "",
                      title: "",
                      content: "",
                    });
                    setHero(temp);
                    setIsChanged(true);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} />
                  Add
                </button>
              </h3>
              {hero.map((value, index) => {
                return (
                  <div key={index} className="sub_card grid">
                    <FontAwesomeIcon
                      icon={faClose}
                      className="sub_card_close"
                      onClick={() => {
                        let temp = [...hero];
                        temp.splice(index, 1);
                        setHero(temp);
                        setIsChanged(true);
                      }}
                    />
                    <div>
                      <p style={{ fontSize: ".9rem" }}>Image</p>
                      {value.image.url ? (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{
                              color: "var(--blue-dark)",
                              cursor: "pointer",
                              height: "15px",
                              width: "15px",
                              padding: "5px",
                              position: "absolute",
                              top: 0,
                              right: 0,
                              transform: "translate(50%, -50%)",
                            }}
                            onClick={() => {
                              let temp = [...hero];
                              temp[index].image = { url: "", obj: "" };
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                          <img
                            src={value.image.url}
                            alt=""
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            position: "relative",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 0,
                              right: 0,
                              opacity: 0,
                            }}
                            accept="image/*"
                            onChange={(e) => {
                              // let temp = [...fold2List];
                              // temp[index].icon = {
                              //   url: URL.createObjectURL(e.target.files[0]),
                              //   obj: e.target.files[0],
                              // };
                              // setFold2List(temp);
                              // setIsChanged(true);
                              let temp = [...hero];
                              temp[index].image = {
                                url: URL.createObjectURL(e.target.files[0]),
                                obj: e.target.files[0],
                              };
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    {value.image?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Caption"}
                          value={value.imageCaption}
                          onChange={(e) => {
                            let temp = [...hero];
                            temp[index].imageCaption = e.target.value;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Alt"}
                          value={value.imageAlt}
                          onChange={(e) => {
                            let temp = [...hero];
                            temp[index].imageAlt = e.target.value;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                    )}
                    <div className="grid">
                      <InputField
                        type="text"
                        value={value.title}
                        onChange={(e) => {
                          if (e.target.value.length <= 40) {
                            let temp = [...hero];
                            temp[index].title = e.target.value;
                            setHero(temp);
                            setIsChanged(true);
                          }
                        }}
                        isLabel={true}
                        lable="Title"
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                        }}
                      >
                        <p style={{ paddingLeft: "5px" }}>Content</p>
                        <TextEditor
                          handleChange={(val) => {
                            let temp = [...hero];
                            temp[index].content = val;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                          content={value.content}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="card grid">
              <h3>Fold 1</h3>
              <InputField
                type="text"
                isLabel={true}
                lable={"Title"}
                value={fold1Title}
                onChange={(e) => {
                  setIsChanged(true);
                  setFold1Title(e.target.value);
                }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <p style={{ paddingLeft: "5px" }}>Description</p>
                <TextEditor
                  handleChange={(val) => {
                    setIsChanged(true);
                    setFold1Description(val);
                  }}
                  content={fold1Description}
                  smallEditor={true}
                />
              </div>
            </div>
            <div className="card grid">
              <h3>
                Fold 2
                <button
                  onClick={() => {
                    setFold2List((prev) => [
                      ...prev,
                      {
                        icon: { url: "", obj: "" },
                        iconCaption: "",
                        iconAlt: "",
                        title: "",
                        description: "",
                      },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              {fold2List.map((value, index) => (
                <div key={index} className="sub_card grid">
                  <FontAwesomeIcon
                    icon={faClose}
                    className="sub_card_close"
                    onClick={() => {
                      let temp = fold2List;
                      temp.splice(index, 1);
                      setFold2List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <div>
                    <p style={{ fontSize: ".9rem" }}>Image</p>
                    {value.icon.url ? (
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          background: "var(--blue-light)",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "5px",
                          position: "relative",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faClose}
                          style={{
                            color: "var(--blue-dark)",
                            cursor: "pointer",
                            height: "15px",
                            width: "15px",
                            padding: "5px",
                            position: "absolute",
                            top: 0,
                            right: 0,
                            transform: "translate(50%, -50%)",
                          }}
                          onClick={() => {
                            let temp = [...fold2List];
                            temp[index].icon = { url: "", obj: "" };
                            setFold2List(temp);
                            setIsChanged(true);
                          }}
                        />
                        <img
                          src={value.icon.url}
                          alt=""
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          position: "relative",
                          background: "var(--blue-light)",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "5px",
                        }}
                      >
                        <input
                          type="file"
                          style={{
                            position: "absolute",
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            opacity: 0,
                          }}
                          accept="image/*"
                          onChange={(e) => {
                            let temp = [...fold2List];
                            temp[index].icon = {
                              url: URL.createObjectURL(e.target.files[0]),
                              obj: e.target.files[0],
                            };
                            setFold2List(temp);
                            setIsChanged(true);
                          }}
                        />
                        <FontAwesomeIcon
                          icon={faPlus}
                          style={{ color: "var(--blue-dark)" }}
                        />
                      </div>
                    )}
                  </div>
                  {value.icon?.url && (
                    <div className="grid_2">
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Caption"}
                        value={value.iconCaption}
                        onChange={(e) => {
                          let temp = [...fold2List];
                          temp[index].iconCaption = e.target.value;
                          setFold2List(temp);
                          setIsChanged(true);
                        }}
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Alt"}
                        value={value.iconAlt}
                        onChange={(e) => {
                          let temp = [...fold2List];
                          temp[index].iconAlt = e.target.value;
                          setFold2List(temp);
                          setIsChanged(true);
                        }}
                      />
                    </div>
                  )}
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Title"}
                    value={value.title}
                    onChange={(e) => {
                      let temp = fold2List;
                      temp[index].title = e.target.value;
                      setFold2List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <p style={{ paddingLeft: "5px" }}>Description</p>
                    <TextEditor
                      handleChange={(val) => {
                        let temp = fold2List;
                        temp[index].description = val;
                        setFold2List([...temp]);
                        setIsChanged(true);
                      }}
                      content={value.description}
                      smallEditor={true}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="card grid">
              <h3>
                Fold 3
                <button
                  onClick={() => {
                    setFold3List((prev) => [
                      ...prev,
                      {
                        number: "",
                        title: "",
                        subTitle: "",
                      },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              {fold3List.map((value, index) => (
                <div key={index} className="sub_card grid">
                  <FontAwesomeIcon
                    icon={faClose}
                    className="sub_card_close"
                    onClick={() => {
                      let temp = fold3List;
                      temp.splice(index, 1);
                      setFold3List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <InputField
                    type="number"
                    isLabel={true}
                    lable={"Number"}
                    value={value.number}
                    onChange={(e) => {
                      let temp = fold3List;
                      temp[index].number = e.target.value;
                      setFold3List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Title"}
                    value={value.title}
                    onChange={(e) => {
                      let temp = fold3List;
                      temp[index].title = e.target.value;
                      setFold3List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Sub Title"}
                    value={value.subTitle}
                    onChange={(e) => {
                      let temp = fold3List;
                      temp[index].subTitle = e.target.value;
                      setFold3List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                </div>
              ))}
            </div>
            <div className="card grid">
              <h3>
                Fold 4
                <button
                  onClick={() => {
                    setFold4List((prev) => [
                      ...prev,
                      {
                        title: "",
                        icon: { url: "", obj: "" },
                        description: "",
                        iconCaption: "",
                        iconAlt: "",
                        showBtn: false,
                        btnText: "",
                        btnUrl: "",
                      },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              {fold4List.length !== 0 && (
                <InputField
                  type="text"
                  isLabel={true}
                  lable="Heading"
                  value={fold4Title}
                  onChange={(e) => setFold4Title(e.target.value)}
                />
              )}
              {fold4List?.map((value, index) => (
                <div key={index} className="sub_card grid">
                  <FontAwesomeIcon
                    icon={faClose}
                    className="sub_card_close"
                    onClick={() => {
                      let temp = fold4List;
                      temp.splice(index, 1);
                      setFold4List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <div>
                    <p style={{ fontSize: ".9rem" }}>Image</p>
                    {value.icon.url ? (
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          background: "var(--blue-light)",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "5px",
                          position: "relative",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faClose}
                          style={{
                            color: "var(--blue-dark)",
                            cursor: "pointer",
                            height: "15px",
                            width: "15px",
                            padding: "5px",
                            position: "absolute",
                            top: 0,
                            right: 0,
                            transform: "translate(50%, -50%)",
                          }}
                          onClick={() => {
                            let temp = [...fold2List];
                            temp[index].icon = { url: "", obj: "" };
                            setFold2List(temp);
                            setIsChanged(true);
                          }}
                        />
                        <img
                          src={value.icon.url}
                          alt=""
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          position: "relative",
                          background: "var(--blue-light)",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "5px",
                        }}
                      >
                        <input
                          type="file"
                          style={{
                            position: "absolute",
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            opacity: 0,
                          }}
                          accept="image/*"
                          onChange={(e) => {
                            let temp = [...fold4List];
                            temp[index].icon = {
                              url: URL.createObjectURL(e.target.files[0]),
                              obj: e.target.files[0],
                            };
                            setFold4List(temp);
                            setIsChanged(true);
                          }}
                        />
                        <FontAwesomeIcon
                          icon={faPlus}
                          style={{ color: "var(--blue-dark)" }}
                        />
                      </div>
                    )}
                  </div>
                  {value.icon?.url && (
                    <div className="grid_2">
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Caption"}
                        value={value.iconCaption}
                        onChange={(e) => {
                          let temp = [...fold4List];
                          temp[index].iconCaption = e.target.value;
                          setFold4List(temp);
                          setIsChanged(true);
                        }}
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Alt"}
                        value={value.iconAlt}
                        onChange={(e) => {
                          let temp = [...fold4List];
                          temp[index].iconAlt = e.target.value;
                          setFold4List(temp);
                          setIsChanged(true);
                        }}
                      />
                    </div>
                  )}
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Title"}
                    value={value.title}
                    onChange={(e) => {
                      let temp = fold4List;
                      temp[index].title = e.target.value;
                      setFold4List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <p style={{ paddingLeft: "5px" }}>Description</p>
                    <TextEditor
                      handleChange={(val) => {
                        let temp = fold4List;
                        temp[index].description = val;
                        setFold4List([...temp]);
                        setIsChanged(true);
                      }}
                      content={value.description}
                      smallEditor={true}
                    />
                  </div>
                  <div className="grid_2">
                    <div
                      style={{
                        height: "50px",
                        width: "100%",
                        border: "1px solid lightgrey",
                        background: "white",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        paddingInline: "15px",
                        justifyContent: "space-between",
                        marginTop: "25px",
                      }}
                    >
                      <p>Show Button</p>
                      <ToggleSwitch
                        value={value.showBtn}
                        onClick={() => {
                          let temp = fold4List;
                          temp[index].showBtn = !value.showBtn;
                          setFold4List([...temp]);
                          setIsChanged(true);
                        }}
                      />
                    </div>
                    {value.showBtn && (
                      <>
                        <InputField
                          type="text"
                          isLabel={true}
                          value={value.btnText}
                          lable="Button Text"
                          placeholder="Enter button text"
                          onChange={(e) => {
                            let temp = fold4List;
                            temp[index].btnText = e.target.value;
                            setFold4List([...temp]);
                            setIsChanged(true);
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          value={value.btnUrl}
                          lable="Button Link"
                          placeholder="Enter button Link"
                          onChange={(e) => {
                            let temp = fold4List;
                            temp[index].btnUrl = e.target.value;
                            setFold4List([...temp]);
                            setIsChanged(true);
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="card grid">
              <h3>
                Fold 5
                <button
                  onClick={() => {
                    setFold5List((prev) => [
                      ...prev,
                      {
                        year: "",
                        awardName: "",
                        description: "",
                      },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              {fold5List.length !== 0 && (
                <InputField
                  type="text"
                  isLabel={true}
                  lable="Heading"
                  value={fold5Title}
                  onChange={(e) => setFold5Title(e.target.value)}
                />
              )}
              {fold5List?.map((value, index) => (
                <div key={index} className="sub_card grid">
                  <FontAwesomeIcon
                    icon={faClose}
                    className="sub_card_close"
                    onClick={() => {
                      let temp = fold5List;
                      temp.splice(index, 1);
                      setFold5List([...temp]);
                      setIsChanged(true);
                    }}
                  />

                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Year"}
                    value={value.year}
                    onChange={(e) => {
                      let temp = fold5List;
                      temp[index].year = e.target.value;
                      setFold5List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Award Name"}
                    value={value.awardName}
                    onChange={(e) => {
                      let temp = fold5List;
                      temp[index].awardName = e.target.value;
                      setFold5List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <p style={{ paddingLeft: "5px" }}>Description</p>
                    <TextEditor
                      handleChange={(val) => {
                        let temp = fold5List;
                        temp[index].description = val;
                        setFold5List([...temp]);
                        setIsChanged(true);
                      }}
                      content={value.description}
                      smallEditor={true}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="card grid">
              <h3>Fold 6</h3>
              <InputField
                type="text"
                isLabel={true}
                lable={"Title"}
                value={fold6Title}
                onChange={(e) => {
                  setIsChanged(true);
                  setFold6Title(e.target.value);
                }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <p style={{ paddingLeft: "5px" }}>Description</p>
                <TextEditor
                  handleChange={(val) => {
                    setIsChanged(true);
                    setFold6Description(val);
                  }}
                  content={fold6Description}
                  smallEditor={true}
                />
              </div>
              <div className="grid_2">
                <div
                  style={{
                    height: "50px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    background: "white",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    paddingInline: "15px",
                    justifyContent: "space-between",
                    marginTop: "25px",
                  }}
                >
                  <p>Show Button</p>
                  <ToggleSwitch
                    value={fold6ShowBtn}
                    onClick={() => {
                      setFold6ShowBtn((prev) => !prev);
                      setIsChanged(true);
                    }}
                  />
                </div>
                {fold6ShowBtn && (
                  <>
                    <InputField
                      type="text"
                      isLabel={true}
                      value={fold6BtnText}
                      lable="Button Text"
                      placeholder="Enter button text"
                      onChange={(e) => {
                        setFold6BtnText(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      value={fold6BtnUrl}
                      lable="Button Link"
                      placeholder="Enter button Link"
                      onChange={(e) => {
                        setFold6BtnUrl(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
            <div className="card grid">
              <h3>Left & Right CTA</h3>
              <InputField
                isLabel={true}
                lable="Left Heading"
                value={bottomSection.left.heading}
                onChange={(e) => {
                  setBottomSection((prev) => ({
                    ...prev,
                    left: { ...prev.left, heading: e.target.value },
                  }));
                  setIsChanged(true);
                }}
              />
              <div className="grid_2">
                <InputField
                  isLabel={true}
                  lable="Left Button Text"
                  value={bottomSection.left.buttonText}
                  onChange={(e) => {
                    setBottomSection((prev) => ({
                      ...prev,
                      left: { ...prev.left, buttonText: e.target.value },
                    }));
                    setIsChanged(true);
                  }}
                />
                <InputField
                  isLabel={true}
                  lable="Left Button URL"
                  value={bottomSection.left.buttonUrl}
                  onChange={(e) => {
                    setBottomSection((prev) => ({
                      ...prev,
                      left: { ...prev.left, buttonUrl: e.target.value },
                    }));
                    setIsChanged(true);
                  }}
                />
              </div>
              <InputField
                isLabel={true}
                lable="Right Heading"
                value={bottomSection.right.heading}
                onChange={(e) => {
                  setBottomSection((prev) => ({
                    ...prev,
                    right: { ...prev.right, heading: e.target.value },
                  }));
                  setIsChanged(true);
                }}
              />
              <div className="grid_2">
                <InputField
                  isLabel={true}
                  lable="Right Button Text"
                  value={bottomSection.right.buttonText}
                  onChange={(e) => {
                    setBottomSection((prev) => ({
                      ...prev,
                      right: { ...prev.right, buttonText: e.target.value },
                    }));
                    setIsChanged(true);
                  }}
                />
                <InputField
                  isLabel={true}
                  lable="Right Button URL"
                  value={bottomSection.right.buttonUrl}
                  onChange={(e) => {
                    setBottomSection((prev) => ({
                      ...prev,
                      right: { ...prev.right, buttonUrl: e.target.value },
                    }));
                    setIsChanged(true);
                  }}
                />
              </div>
            </div>
            <div className="card grid">
              <InputField
                isLabel={true}
                lable="Slug"
                value={slug}
                onChange={(e) => {
                  setSlug(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Title"
                value={metaTitle}
                onChange={(e) => {
                  setMetaTitle(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Image Url"
                value={metaImageUrl}
                onChange={(e) => {
                  setMetaImageUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Description"
                value={metaDescription}
                onChange={(e) => {
                  setMetaDescription(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Canonical Url"
                value={canonicalUrl}
                onChange={(e) => {
                  setCanonicalUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
            </div>
          </div>
        </ContentBody>
      </Content>
    </>
  );
};

export default About;
